// Module
var code = "<div class=\"dns-txt-record\"> <h3>Text Records</h3> <div class=\"clr-wrapper dns-txt-record__add-container\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.addTxtRecord()\"> Add </button> </div> <grid config=\"::$ctrl.txtRecordsGridConfig\" rows=\"$ctrl.txtRecords\"></grid> </div> ";
// Exports
export default code;